import { AvatarOwnProps, Badge, Box, CircularProgress, styled } from '@mui/material';

import { theme } from '@itp/talent/theme';


export const LoaderOverlay = styled(Box)(({ variant }: { variant: AvatarOwnProps['variant'] }) => ({
  alignItems: 'center',
  borderRadius: variant === 'circular' ? '50%' : theme.spacing(0.5),
  display: 'flex',
  height: '100%',
  justifyContent: 'center',
  left: 0,
  position: 'absolute',
  top: 0,
  width: '100%',
  zIndex: 1,
}));

export const StyledProgress = styled(CircularProgress)`
  color: white;
`;

export const StyledBadge = styled(Badge, {
  shouldForwardProp: (prop) => prop !== 'online',
})<{ online: boolean }>(({ online, theme }) => ({
  '& .MuiBadge-dot': {
    backgroundColor: online ? theme.palette.success.main : theme.palette.grey[300],
    border: `2px solid ${theme.palette.background.paper}`,
    borderRadius: '50%',
    height: '10px',
    width: '10px',
    zIndex: 10,
  },
}));
